import type { StatsPeriod } from '@/types/dmAutomation';

export const queryKeys = {
    instagram: {
        all: ['instagram'] as const,
        status: (withProfile: boolean) => ['instagram', 'status', { withProfile }] as const,
        media: (limit: number) => ['instagram', 'media', 'list', { limit }] as const,
        mediaByIds: (ids: string[]) => ['instagram', 'media', 'by-ids', [...ids].sort()] as const,
    },
    dmAutomation: {
        all: ['dm-automation'] as const,
        list: () => ['dm-automation', 'list'] as const,
        statsOverview: () => ['dm-automation', 'stats', 'overview'] as const,
        stats: (id: string, period: StatsPeriod) => ['dm-automation', id, 'stats', period] as const,
        logs: (id: string, page: number, limit: number) =>
            ['dm-automation', id, 'logs', { page, limit }] as const,
    },
    subscription: {
        all: ['subscription'] as const,
        plans: () => ['subscription', 'plans'] as const,
        plan: (code: string) => ['subscription', 'plans', code] as const,
        features: () => ['subscription', 'features'] as const,
        paymentMethods: () => ['subscription', 'payment-methods'] as const,
        me: () => ['subscription', 'me'] as const,
        snapshot: () => ['subscription', 'me', 'snapshot'] as const,
        changeHistory: () => ['subscription', 'me', 'change-history'] as const,
        payments: () => ['subscription', 'payments'] as const,
        payment: (id: string) => ['subscription', 'payments', id] as const,
        usage: () => ['subscription', 'usage'] as const,
        featureUsage: (featureCode: string) => ['subscription', 'usage', featureCode] as const,
    },
} as const;
